import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { PlusIcon } from "lucide-react";
import { TEMPLATE_CARD_BASE } from "./template-card.styles";

type NewTemplateCardProps = {
  onClick?: () => void;
};

export function NewTemplateCard({ onClick }: NewTemplateCardProps) {
  return (
    <Card
      onClick={onClick}
      className={`group ${TEMPLATE_CARD_BASE} cursor-pointer border-muted-foreground/25 bg-transparent transition-all hover:border-primary/50 hover:bg-primary/5`}
    >
      <CardHeader className="flex-1 p-4 pb-2">
        <div className="flex flex-col items-center justify-center gap-2.5 py-1 text-center">
          <div className="flex size-10 items-center justify-center rounded-full bg-primary/10 text-primary transition-colors group-hover:bg-primary/20">
            <PlusIcon className="size-5" />
          </div>
          <div>
            <CardTitle className="text-base">Create New Template</CardTitle>
            <CardDescription className="mt-0.5">
              Build a reusable analysis workflow
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <div className="text-center text-xs text-muted-foreground">
          Click to get started
        </div>
      </CardContent>
    </Card>
  );
}
